export const fieldsAreEmpty = fields => {
  const values = Object.values(fields)
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < values.length; i++) {
    if (values[i] === '') return true
  }
  return false
}
